module.exports = __webpack_public_path__ + "static/media/ModalBanner.e0fb654a.jpg";